import{ useState, useCallback, useRef } from 'react';
import AsyncSelect from 'react-select/async';
import { Dropdown } from 'bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Filters = ({ filterFields, onApplyFilters, getFilterService , getDateFilterService }) => {
    const [filters, setFilters] = useState({});
    const [selectedOptions, setSelectedOptions] = useState({});
    const [inputValues, setInputValues] = useState({});
    const dropdownRef = useRef(null);
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    }, []);

    const handleFieldChange = useCallback((fieldName, selectedOption) => {
        setFilters((prev) => ({
            ...prev,
            [fieldName]: selectedOption ? selectedOption.value : '',
        }));

        setSelectedOptions((prev) => ({
            ...prev,
            [fieldName]: selectedOption || null,
        }));
    }, []);

    const closeDropdown = () => {
        if (dropdownRef.current) {
            const dropdown = Dropdown.getInstance(dropdownRef.current);
            if (dropdown) {
                dropdown.hide();
            }
        }
    };

    const handleFilterSubmit = useCallback(async (e) => {
    e.preventDefault();

    const dateFields = filterFields.filter(field => field.DateDropdown === 'yes');
    const dateFilters = {};
    const otherFilters = {};

    for (const key in filters) {
        if (dateFields.find(field => field.name === key)) {
            dateFilters[key] = filters[key];  // ✅ collect date fields
        } else {
            otherFilters[key] = filters[key]; // ✅ other filters
        }
    }

    try {

        onApplyFilters({ ...dateFilters, ...otherFilters });

    } catch (error) {
        console.error("Error submitting filters:", error);
    }

    closeDropdown();
}, [filters, filterFields, onApplyFilters, getDateFilterService]);



    const handleReset = () => {
        const emptyFilters = {};
        setFilters(emptyFilters);
        setSelectedOptions({});
        onApplyFilters(emptyFilters);
        closeDropdown();
    };

    const loadOptions = useCallback(async (fieldName, inputValue, callback, service) => {
        try {
            const response = await service({
                field: fieldName,
                search: inputValue,
            });

            if (response.data?.success && Array.isArray(response.data.data)) {
                const options = response.data.data.map((item) => {

                    if (item.company !== undefined) {
                        const useName = fieldName === 'customer_id';
                        return {
                            value: useName ? item.id : item.company,
                            label: item.company,
                        };
                    }

                    if (item.id !== undefined && item.name !== undefined) {
                        const useName = fieldName === 'name';
                        return {
                            value: useName ? item.name : item.id,
                            label: item.name,
                        };
                    }

                    else {
                        return {
                            value: item[fieldName],
                            label: item[fieldName],
                        };
                    }
                });

                callback(options);
            } else {
                callback([]);
            }
        } catch (error) {
            console.error(`Error fetching ${fieldName} options:`, error);
            callback([]);
        }
    }, [getFilterService]);

    const renderField = (field) => {
        const matchedField = filterFields.find(f => f.name === field.name);

        if (matchedField?.Dropdown === 'yes') {
            return (
                <AsyncSelect
                    isClearable
                    placeholder={field.placeholder}
                    value={selectedOptions[field.name] || null}
                    loadOptions={(inputValue, callback) =>
                        loadOptions(field.name, inputValue, callback, getFilterService)
                    }
                    onInputChange={(newValue) => {
                        setInputValues((prev) => ({
                            ...prev,
                            [field.name]: newValue,
                        }));
                        return newValue;
                    }}
                    onChange={(selectedOption) => {
                        console.log('Selected Option:', selectedOption);
                        handleFieldChange(field.name, selectedOption);
                    }}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    menuIsOpen={!!inputValues[field.name]}
                />
            );
        }

       if (matchedField?.DateDropdown === 'yes') {
    return (
        <div className="form-group mb-0">
            <DatePicker
                selected={filters[field.name] ? new Date(filters[field.name]) : null}
                onChange={(date) => {
                    setFilters((prev) => ({
                        ...prev,
                        [field.name]: date ? date.toISOString().split('T')[0] : '',
                    }));
                }}
                placeholderText={field.placeholder || (field.name === 'start_date' ? 'Start Date' : 'End Date')}
                className="form-control custom-datepicker"
                dateFormat="yyyy-MM-dd"
                style={{ width: '100%' }}
            />
        </div>
    );
}


        return (
            <input
                type="text"
                className="form-control"
                name={field.name}
                value={filters[field.name] || ''}
                onChange={handleInputChange}
                placeholder={field.placeholder}
            />
        );
    };
    return (
        <div className="dropdown">
            <button
                ref={dropdownRef}
                className="btn btn-sm btn-white"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-haspopup="true"
            >
                <i className="fe fe-sliders me-1" /> Filter <span className="badge bg-primary ms-1 d-none">0</span>
            </button>
            <form
                className="dropdown-menu dropdown-menu-end dropdown-menu-card"
                onSubmit={handleFilterSubmit}
                style={{ width: '550px' }}
            >
                <div className="card-header">
                    <h4 className="card-header-title">Filters</h4>
                </div>
                <div className="card-body">
                    <div className="list-group list-group-flush mt-n4">
                        <div className="row">
                            {filterFields.map((field) => (
                                <div key={field.name} className="mt-3 col-12 col-md-6">
                                    {renderField(field)}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <button className="btn btn-sm btn-primary me-2" type="submit">
                        Apply
                    </button>
                    <button className="btn btn-sm btn-danger" type="button" onClick={handleReset}>
                        Reset
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Filters;
